module.exports = __webpack_public_path__ + "img/IMÁGENES CLÍNICAS KC7 1.b2f31612.png";